import { combineReducers } from '@reduxjs/toolkit';
import { entityImportReducer } from './entityImporter/slice';
import users from './users/reducers';
import user from './user/reducers';
import clients from './clients/reducers';
import ui from './ui/reducers';
import runtime from './runtime/reducers';
import data from './data/reducers';
import settings from './settings/reducers';
import files from './files/reducers';
import messages from './messages/reducers';
import payments from './payments/reducers';
import landings from './landing/reducers';
import notifications from './notifications/reducers';
import tasks from './tasks/reducers';
import intakeForms from './intake_forms/reducers';
import signaturePage from './signaturePage/reducers';
import dashboard from './dashboard/reducers';
import { shortcutsReducer } from './shortcuts/slice';

import tags from './tags/reducers';
import knowledgeBase from './knowledgeBase/reducers';
import tableProperties from './tableProperties/reducers';
import { appAPI } from '../services/api';

export const rootReducer = combineReducers({
  clients,
  users,
  user,
  ui,
  runtime,
  data,
  settings,
  files,
  messages,
  payments,
  landings,
  notifications,
  tasks,
  intakeForms,
  signaturePage,
  dashboard,
  shortcuts: shortcutsReducer,
  entityImports: entityImportReducer,
  tags,
  knowledgeBase,
  tableProperties,
  [appAPI.reducerPath]: appAPI.reducer,
});
